/*
 * Skippair implementation of Google Map for cruise search
 *
 *
 *
 *
 */

import * as loadGoogleMapsAPI from 'load-google-maps-api'
import $ from 'jquery'
import MarkerClusterer from './utils/marker-clusterer.js'

const SearchGoogleMap = (function() {
    // STATIC
    var MAP_STYLE = [{ "featureType": "landscape", "stylers": [{ "hue": "#FFBB00" }, { "saturation": 43.400000000000006 }, { "lightness": 37.599999999999994 }, { "gamma": 1 }] }, { "featureType": "road.highway", "stylers": [{ "hue": "#FFC200" }, { "saturation": -61.8 }, { "lightness": 45.599999999999994 }, { "gamma": 1 }] }, { "featureType": "road.arterial", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 51.19999999999999 }, { "gamma": 1 }] }, { "featureType": "road.local", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 52 }, { "gamma": 1 }] }, { "featureType": "water", "stylers": [{ "hue": "#0078FF" }, { "saturation": -13.200000000000003 }, { "lightness": 2.4000000000000057 }, { "gamma": 1 }] }, { "featureType": "poi", "stylers": [{ "hue": "#00FF6A" }, { "saturation": -1.0989010989011234 }, { "lightness": 11.200000000000017 }, { "gamma": 1 }] }];

    // PRIVATE
    var _selfMap;
    var _self;
    var _markersOnMap = [];
    var _markerClusterer;
    var _callbacks = [];
    var _cancelUserMove = true;
    var _option;
    var _icons;
    var _enableAutoRefresh = false;
    var google = {
        'map':undefined,
    };

    // ====================== CONSTRUCTOR ======================
    /*
     * Create marker from the data
     * @param {Object} option - The option apply to the map. 
     */
    function SearchGoogleMap(option) {
        _self = this;

        // Load google map API
        loadGoogleMapsAPI({ key: 'AIzaSyCva6GGkaSvOfjSjGvjgw3mTsWR2hkkwBQ'}).then(onGoogleMapLoad).catch((err) => {
            console.error(err)
        });

        function onGoogleMapLoad(googleMaps) {
            google.maps = googleMaps;

            _option = option || {};

            // Create the map
            _selfMap = new google.maps.Map(document.getElementById('map'), {
                center: new google.maps.LatLng(0, 20),
                zoom: 2,
                minZoom: 2,
                scrollwheel: false,
                streetViewControl: false,
                mapTypeControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.TOP_LEFT
                },
            });

            // Associate the styled map with the MapTypeId and set it to display.
            // _selfMap.mapTypes.set('styled_map', new google.maps.StyledMapType(MAP_STYLE, { name: 'Styled Map' }));
            // _selfMap.setMapTypeId('styled_map');

            // Associate listener
            _selfMap.addListener('idle', _onIdle);


            // Add new function to the prototype of Google map Marker
            _extandGoogleMapMarkers();

            // Create an empty cluster
            _markerClusterer = new MarkerClusterer(_selfMap, _markersOnMap, {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/',
                minimumClusterSize: 2,
                gridSize: 25,
            });

            // Create a Custom Control for map
            _selfMap.controls[google.maps.ControlPosition.TOP_LEFT].push($("#search-on-map")[0]);

            // Manual refresh
            $(".map-manual-refresh").on('click', function() {
                $(".map-manual-refresh").hide();
                _dispatchEvent('userMove');
            });

            _dispatchEvent('mapReady');
        };
    };

    // ===================== PUBLIC METHOD =====================
    /*
     * Create one marker and return it
     * @param {Marker} googleMapMarker - The marker to create on the map.
     */
    SearchGoogleMap.prototype.addToMap = function(googleMapMarker) {
        _markerClusterer.addMarker(googleMapMarker);
        _markersOnMap.push(googleMapMarker);
    };

    /*
     * Create one marker and return it
     * @param {Marker} marker - The marker to create on the map.
     */
    SearchGoogleMap.prototype.createMarker = function(marker) {

        let args = {
            position: marker.pos
            //icon:_icons['diving']
        }
        if(marker.cruiseNb > 1) {
            args['label'] = {
                text: String(marker.cruiseNb)} 
        }
        var mapMarker = new google.maps.Marker(args);
        mapMarker.id = marker.id;

        function onInfoWindowHtmlReady(marker) {
            mapMarker = marker.googleMapMarker
            mapMarker.createInfoWindow(marker.infoWindowHtml)
            mapMarker.infowindow.open(mapMarker._selfMap, mapMarker)
        }

        mapMarker.addListener('click', function() {
            marker.updateCruiseData(onInfoWindowHtmlReady)
        });

        
        this.addToMap(mapMarker);
        return mapMarker;
    };

    /*
     * Delete all markers and all infowindow associed to it.
     * @param {Objects[]} portList - the list of marker to NOT delete.
     */
    SearchGoogleMap.prototype.deleteMarkers = function(portList) {
        var markersOnMap = _markerClusterer.getMarkers();

        // For all markers, delete the infowindow and deassociate the marker from the map
        for (var i = 0; i < markersOnMap.length; i++) {
            // markersOnMap[i].close();
            // markersOnMap[i].infowindow.status = 'close';
            // Check if it's in the port list
            // markersOnMap[i].keep = false;
            // for (var j = portList.length - 1; j >= 0; j--) {
            //     if (markersOnMap[i].id == portList[j].id)
            //         markersOnMap[i].keep = true;
            // }
            // if (!markersOnMap[i].keep)
            //     _markerClusterer.removeMarker(markersOnMap[i]);
        }

        // Delete cluster;
        _markerClusterer.clearMarkers();
        // Clear the marker table.
        _markersOnMap = _markerClusterer.getMarkers();
        return this;
    };

    /*
     * Close all infowindow.
     */
    SearchGoogleMap.prototype.closeAllInfoWindows = function() {
        for (var i in _markersOnMap) {
            _markersOnMap[i].close();
        }
        return this;
    };

    /*
     * Fit the map boundaries to the ports given.
     * @param {Objects[]} portList - the list of marker to fit.
     */
    SearchGoogleMap.prototype.fitMapToMarkers = function(portList) {
        _desactivateUserMove();
        if (portList.length == 0) {
            _selfMap.setCenter(new google.maps.LatLng(0, 20));
            _selfMap.setZoom(2);
        } else if (portList.length == 1) {
            _selfMap.setCenter(portList[0].pos);
            _selfMap.setZoom(9);
        } else {
            var bounds = { 'min-lat': portList[0].pos.lat, 'min-lng': portList[0].pos.lng, 'max-lat': portList[0].pos.lat, 'max-lng': portList[0].pos.lng };

            for (var i = 1; i < portList.length; i++)
                bounds = {
                    'min-lat': Math.min(bounds['min-lat'], portList[i].pos.lat),
                    'min-lng': Math.min(bounds['min-lng'], portList[i].pos.lng),
                    'max-lat': Math.max(bounds['max-lat'], portList[i].pos.lat),
                    'max-lng': Math.max(bounds['max-lng'], portList[i].pos.lng)
                };

            _selfMap.fitBounds(new google.maps.LatLngBounds({
                'lat': bounds['min-lat'],
                'lng': bounds['min-lng']
            }, {
                'lat': bounds['max-lat'],
                'lng': bounds['max-lng']
            }));
        }
    };

    /*
     * Public function for event listening.
     * @param {String} event - The type of the event you want to subscribe.
     * @param {Function} callback - The function to call when the event occur.
     * @param {Object} target - The target to apply to the callback, it will be the this when the function is call. 
     */
    SearchGoogleMap.prototype.on = function(event, callback, target) {
        _callbacks.push({
            'event': event,
            'callback': callback,
            'target': target
        });
    };

    // ===================== Event METHOD =====================
    /*
     * Event call when the idle event is trigger by the Google Map.
     */
    function _onIdle() {
        if (!_cancelUserMove)
            if (_enableAutoRefresh)
                _dispatchEvent('userMove');
            else {
                $(".map-manual-refresh").show();
            }

    }

    function _dispatchEvent(event) {
        for (var i = _callbacks.length - 1; i >= 0; i--) {
            if (_callbacks[i].event == event)
                _callbacks[i].callback(_selfMap);
        }
    }

    // ===================== PRIVATE METHOD =====================
    /*
     * Cancel the 'userMove' event for 1000 ms (1s).
     */
    function _desactivateUserMove() {
        _cancelUserMove = true;
        window.setTimeout(function() {
            _cancelUserMove = false;
        }, 1000);
    }


    /*
     * Add new method to the prototype of Google map Marker object
     */
    function _extandGoogleMapMarkers() {
        /*
         * Create an info window associed to the marker.
         * @param {string} content - The content of the InfoWindow.
         */
        google.maps.Marker.prototype.createInfoWindow = function(content) {
            // this.setIcon(_icons['ready']);
            this.infowindow = new google.maps.InfoWindow({ content: content });
            this.infowindow['status'] = 'close';

            this.close = function() {
                this.infowindow.status = 'close';
                this.infowindow.close()
            };

            this.open = function() {
                _desactivateUserMove();
                this.infowindow.status = 'open';
                this.infowindow.open(_selfMap, this);
            };

            function toogleInfowindow() {
                if (this.infowindow.status == 'close') {
                    _self.closeAllInfoWindows();
                    this.open();
                } else
                    this.close();
            }

            this.addListener('click', toogleInfowindow);
            this.infowindow.addListener('closeclick', function() {
                this.status = 'close';
            });

            google.maps.event.addListener(this.infowindow, 'domready', function() {
                if (_option.defaultIW)
                    return;
                var iwOuter = $('.gm-style-iw');
                var iwBackground = iwOuter.prev();
                var iwParent = iwOuter.parent();
                iwBackground.css({
                    'display': 'none'
                });
                iwParent.css({
                    "max-width": "235px",
                    "max-height": "275px",
                });
            });
        };

        /*
         * Update the content of the info window.
         * @param {string} content - The new content of the InfoWindow.
         */
        google.maps.Marker.prototype.updateInfoWindow = function(content) {
            if (this.infowindow == undefined)
                this.createInfoWindow(content);
            else
                this.infowindow.content = content;
        };
    }

    return SearchGoogleMap
})();

export default SearchGoogleMap


// WEBPACK FOOTER //
// ./search/static/search/js/searchGoogleMap.js